/* unplugin-vue-components disabled *//* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swipe, SwipeItem } from 'vant';
export default {
  name: 'Banner',
  props: {
    bannerList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    Swipe: Swipe,
    SwipeItem: SwipeItem
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {}
};